import { validate, ValidatorResult } from 'jsonschema';

export const jsonSchemaValidator = (
  label: string,
  value: JSON,
  schema: unknown
): ValidatorResult => {
  // console.log('Incoming object for: ', label, value);
  const validationResult = validate(value, schema, {
    base: 'https://midocean.com',
  });

  // console.log(
  //   `%c validation result: ${validationResult.valid}`,
  //   validationResult.valid
  //     ? 'background-color: #00ff00; padding: 0.2rem'
  //     : 'background-color: #ff0000; padding: 0.2rem; color: white'
  // );

  // console.groupCollapsed(`property setter validation error for ${label}`);
  // validationResult.errors.map(({ path, message }) => {
  //   console.warn(path, message);
  // });
  // console.groupEnd();

  return validationResult;
};
